<template>
  <v-card-actions>
    <FileForm
      ref="docForm"
      :mimeTypes="mimeTypes"
      :files="[]"
      :idx="fileKey"
    />
    <v-btn
      :color="color"
      left
      outlined
      :icon="icon"
      :small="small"
      :rounded="rounded"
      :disabled="disabled"
      @click="onPickFile({
        loadedEvent,
        deleteEvent: deletedEvent,
        key: fileKey}
      )"
    >
      <v-icon v-if="icon">
        mdi-plus
      </v-icon>
      <span v-else>      {{ icon ? undefined : label }}</span>
    </v-btn>
  </v-card-actions>
</template>

<script>
import FileForm from '@/components/common/files/load/load-file-form.vue'
import { mapMutations } from 'vuex'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'
import MediaMixin from '@/mixins/mediaMixin'

export default {
  name: 'WBDFileUploaderBtn',
  components: {
    FileForm,
  },
  mixins: [MediaMixin],
  props: {
    mimeTypes: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'success',
    },
    label: {
      type: String
    },
    deletedEvent: {
      type: String
    },
    loadedEvent: {
      type: String
    },
    fileKey: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    extraSet: {
      type: Object
    },
    callback: {
      type: Function
    }
  },
  data: () => ({
  }),
  created () {
    this.eventsBus.$on(this.loadedEvent, this.onFileLoaded)
    this.eventsBus.$on(this.deletedEvent, this.onDeleted)
  },
  methods: {
    ...mapMutations({
      setFileEvents: storeUtils.setterName(storeLabel.FILE_EVENTS, storeLabel.COMMON_MODULE),
    }),
    onPickFile (events) {
      this.setFileEvents(events)
      this.$el.querySelector(`#imageInput_${events.key}`).click()
    },
    async onFileLoaded (file) {
      const res = await this.uploadMedia(
        file.file,
        undefined,
        this.fileKey,
        undefined,
        null,
        null,
        undefined,
        this.extraSet
      )

      if (this.callback) {
        this.callback(res)
      }
    },
    onDeleted (file) {
    },
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
</style>

